import dayjs from 'dayjs';
import { useTranslation } from '@testsigma/atoms';

interface TrailExpiryBannerPros {
  canShowExpiry;
  session;
}

export const TrailExpiryBanner: React.FC<TrailExpiryBannerPros> = ({
  canShowExpiry,
  session,
}) => {
  const nextRenewalAt = session?.tenant?.subscription?.nextRenewalAt;
  const trailDays = dayjs(nextRenewalAt).diff(dayjs(), 'days', false);
  const { t } = useTranslation();

  return (
    canShowExpiry && (
      <div className='w-full relative flex flex-row items-center justify-center'>
        <div className='ac_status_content'>
          <span>{t('trail_expiry_banner.note', { trailDays })}</span>
          <a
            className='px-1.5 text-link'
            href={session?.user?.isAdmin ? '/ui/settings/billing' : ''}
            target={session?.user?.isAdmin ? '_self' : '_blank'}
            rel='noreferrer'>
            {t('trail_expiry_banner.subscribe')}
          </a>
          <span>{t('trail_expiry_banner.suitable_plan')}</span>
          <a href='javascript:fcWidget.open()' className='px-1.5 text-link'>
            {t('trail_expiry_banner.talk_to_us')}
          </a>
          <span>{t('trail_expiry_banner.extend')}</span>
        </div>
      </div>
    )
  );
};
